import {
  Text,
  ExpandableWrapper,
  Tooltip,
  List,
  Grid,
  Spacer,
  Tag,
} from '@piwikpro/ui-components';

import { Incident } from '../model';
import { formatTime, severityIcon, statusTooltip } from '../helpers';

const IncidentDetails: React.FC<{
  incident: Incident | undefined | null;
  component: string;
}> = ({ incident, component }) => {
  if (!incident) return null;
  const severity =
    incident.affected.find((c) => c.name === component)?.severity ?? '';
  const options: Intl.DateTimeFormatOptions = {
    dateStyle: 'medium',
    timeStyle: 'medium',
    hour12: true,
  };
  enum TagColor {
    Gray = 'gray',
    Blue = 'blue',
    Green = 'green',
  }
  const statusColors: { [key: string]: TagColor } = {
    Identified: TagColor.Gray,
    Updated: TagColor.Blue,
    Resolved: TagColor.Green,
  };
  return (
    <List.Item
      key={incident.id}
      columns={[{ align: 'left', size: 1 }]}
      withExpand
    >
      <Text>
        {severityIcon(severity)} {formatTime(incident)}
      </Text>
      <ExpandableWrapper>
        <Tooltip
          content={statusTooltip}
          title={'Legend'}
          inlineActivator={true}
          position={'bottom-start'}
        >
          &nbsp;
        </Tooltip>
        {incident.details.map((inc) => (
          <Grid
            key={inc.timestamp}
            columnsTemplate={inc.status ? '1fr 14fr' : '14fr'}
            rowsTemplate="1fr 1fr"
          >
            {inc.status && (
              <Grid.Item>
                <Tag
                  color={statusColors[inc.status] ?? TagColor.Gray}
                  isRemovable={false}
                >
                  {inc.status}
                </Tag>
              </Grid.Item>
            )}
            <Grid.Item>
              <div
                style={{
                  color: 'grey',
                  fontSize: '13px',
                  minHeight: '24px',
                  padding: '4px',
                }}
              >
                {new Date(inc.timestamp).toLocaleString('en-GB', options)}
              </div>
            </Grid.Item>
            <Grid.Item columns={2}>
              <Text type={'subdued'}>{inc.text}</Text>
            </Grid.Item>
            <Grid.Item columns={2}>
              <Spacer></Spacer>
            </Grid.Item>
          </Grid>
        ))}
      </ExpandableWrapper>
    </List.Item>
  );
};

export { IncidentDetails };
